import React from "react";
import { Helmet } from "react-helmet";
import Section1 from "./Section1";
import Section2 from "./Section2";
import Section3 from "./Section3";
import Section4 from "./Section4";
import Section5 from "./Section5";
import Section6 from "./Section6";
import Section7 from "./Section7";
import Section8 from "./Section8";
import Section9 from "./Section9";



export default function Home() {
  const schemaData = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Organization",
        "@id": "https://mean3.com/#organization",
        "name": "Mean3",
        "url": "https://mean3.com/",
        "logo": "https://mean3.com/assets/mean3-logo.png",
        "description": "Mean3 is a full-service digital marketing and software agency providing ecommerce development, website and mobile application development, digital marketing, graphic design, and staff augmentation services. With offices in Pakistan, and the United States, we help businesses worldwide build, launch, and grow their online presence.",
        "email": "info@mean3.com",
        "foundingDate": "2017",
        "sameAs": [
          "https://www.facebook.com/Mean3.web/",
          "https://www.instagram.com/mean3.pvt.ltd/",
          "https://www.linkedin.com/company/mean3",
          "https://www.youtube.com/@Mean3"
        ],
        "contactPoint": [
          {
            "@type": "ContactPoint",
            "telephone": "+1-832-278-2928",
            "email": "info@mean3.com",
            "contactType": "customer service",
            "areaServed": "US",
            "availableLanguage": ["English"]
          },
          {
            "@type": "ContactPoint",
            "telephone": "+92-331-4016473",
            "email": "info@mean3.com",
            "contactType": "customer service",
            "areaServed": "PK",
            "availableLanguage": ["English"]
          }
        ],
        "areaServed": [
          { "@type": "Country", "name": "United States" },
          { "@type": "Country", "name": "Pakistan" }
        ],
        "knowsAbout": [
          "Shopify Plus Development",
          "Ecommerce Development",
          "Website Development",
          "Mobile App Development",
          "Game Development",
          "Digital Marketing",
          "Search Engine Optimization (SEO)",
          "Graphic Design",
          "Staff Augmentation",
          "ERP Services",
          "UI/UX Design",
          "WordPress Development",
          "WooCommerce Development",
          "BigCommerce Development"
        ],
        "hasOfferCatalog": {
          "@type": "OfferCatalog",
          "name": "Services",
          "itemListElement": [
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "Shopify Plus Development",
                "url": "https://mean3.com/shopify-plus-development",
                "description": "Enterprise-grade Shopify Plus design, development, integrations, and migrations for high-growth brands."
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "Shopify Plus Development",
                "url": "https://mean3.com/shopify-plus-development-ny",
                "description": "Enterprise-grade Shopify Plus design, development, integrations, and migrations for high-growth brands."
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "Digital Marketing",
                "url": "https://mean3.com/digital-marketing-services",
                "description": "SEO, PPC, social media, content, and CRO to drive qualified traffic and conversions."
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "Search Engine Optimization (SEO)",
                "url": "https://mean3.com/search-engine-optimization-services",
                "description": "Technical SEO, on-page optimization, and authority building for sustainable organic growth."
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "Web Development",
                "url": "https://mean3.com/website-design-and-develpment",
                "description": "Custom websites and performance-focused builds aligned to business and user goals."
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "Graphic Design",
                "url": "https://mean3.com/graphic-designing-services",
                "description": "Branding, UI/UX, and creative assets that elevate product and brand experiences."
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "Game Design & Development",
                "url": "https://mean3.com/game-design-and-development",
                "description": "Cross-platform 2D/3D game development for Android, iOS, and desktop."
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "ERP Services",
                "url": "https://mean3.com/erp",
                "description": "Implementation and customization of ERP solutions to streamline operations."
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "Staff Augmentation",
                "url": "https://mean3.com/staff-augmentation-service",
                "description": "On-demand engineers and specialists to extend your in-house capabilities."
              }
            }
          ]
        }
      },
      {
        "@type": "WebSite",
        "@id": "https://mean3.com/#website",
        "url": "https://mean3.com/",
        "name": "Mean3",
        "publisher": { "@id": "https://mean3.com/#organization" },
        "inLanguage": "en",
        "potentialAction": {
          "@type": "SearchAction",
          "target": "https://mean3.com/?s={search_term_string}",
          "query-input": "required name=search_term_string"
        }
      },
      {
        "@type": "WebPage",
        "@id": "https://mean3.com/#webpage",
        "url": "https://mean3.com/",
        "name": "Mean3 — Website, Mobile, Game, ERP & Software Development",
        "isPartOf": { "@id": "https://mean3.com/#website" },
        "about": { "@id": "https://mean3.com/#organization" },
        "primaryImageOfPage": {
          "@type": "ImageObject",
          "url": "https://mean3.com/assets/mean3-logo.png"
        },
        "mainEntityOfPage": { "@id": "https://mean3.com/#webpage" }
      },
      {
        "@type": ["LocalBusiness", "ProfessionalService"],
        "@id": "https://mean3.com/#office-us",
        "name": "Mean3 — USA Office",
        "url": "https://mean3.com/",
        "image": "https://mean3.com/assets/mean3-logo.png",
        "parentOrganization": { "@id": "https://mean3.com/#organization" },
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "447 Broadway, 2nd Floor Suite #670",
          "addressLocality": "New York",
          "addressRegion": "NY",
          "postalCode": "10013",
          "addressCountry": "US"
        },
        "telephone": "+1-832-278-2928",
        "hasMap": "https://maps.google.com/?q=447+Broadway+2nd+Floor+Suite+%23670+New+York+NY+10013"
      },
      {
        "@type": ["LocalBusiness", "ProfessionalService"],
        "@id": "https://mean3.com/#office-pk",
        "name": "Mean3 — Pakistan Office",
        "url": "https://mean3.com/",
        "image": "https://mean3.com/assets/mean3-logo.png",
        "parentOrganization": { "@id": "https://mean3.com/#organization" },
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "2nd floor, 48-B Miran Mohammed Shah Rd, Mohammad Ali Society (MACHS)",
          "addressLocality": "Karachi",
          "addressCountry": "PK"
        },
        "telephone": "+92-331-4016473",
        "hasMap": "https://maps.google.com/?q=2nd+floor%2C+48-B+Miran+Mohammed+Shah+Rd%2C+Mohammad+Ali+Society+Karachi+PK"
      }
    ]
  };

  return (
    <div className="Home pt-[160px] sm:pt-0">
      <Helmet>
        <title>
          Website | Mobile | Game | Software | Development - Mean3 Pvt Ltd
        </title>
        <meta
          name="description"
          content="We provide Digital Marketing (Social Media Marketing), Branding, Website, Mobile Application, Game & Software development services. With more than 80 clients served from all over the world."
        />
        <script type="application/ld+json">
          {JSON.stringify(schemaData)}
        </script>
      </Helmet>

      <Section1 />
      <Section2 />
      <Section3 />
      <Section9 />
      <Section4 />
      <Section8 />
      <Section5 />
      <Section6 />
      <Section7 />
    </div>
  );
}
